/*
Grommets

  --liner <bool> | checkbox
*/

import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Liner',
    value: 'liner',
    type: 'checkbox'
  }
]
